(function () {
  function setupWordmark(wordmark) {
    if (wordmark.dataset.coWordmarkReady === 'true') return;
    const home = wordmark.closest('.co-home');
    const origin = home && home.querySelector('[data-co-wordmark-origin]');
    const target = home && home.querySelector('[data-co-wordmark-target]');
    const targetMark = home && home.querySelector('.co-nav__text-brand');
    const hero = home && home.querySelector('.co-hero');
    if (!home || !origin || !target || !hero) return;
    wordmark.dataset.coWordmarkReady = 'true';
    wordmark.classList.add('is-ready');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const scrollLinked = CSS.supports && CSS.supports('animation-timeline: scroll()');

    function measure() {
      const originBox = origin.getBoundingClientRect();
      // Measure the visible lockup bounds, not the wider header grid cell.
      // This keeps the animated endpoint identical to the settled brand position.
      const markParts = targetMark && targetMark.querySelectorAll('img');
      const targetBox = markParts && markParts.length
        ? Array.from(markParts).reduce((bounds, part) => {
          const rect = part.getBoundingClientRect();
          const right = Math.max(bounds.right, rect.right);
          const bottom = Math.max(bounds.bottom, rect.bottom);
          return {
            left: Math.min(bounds.left, rect.left),
            top: Math.min(bounds.top, rect.top),
            right,
            bottom,
            width: right - Math.min(bounds.left, rect.left),
            height: bottom - Math.min(bounds.top, rect.top)
          };
        }, { left: Infinity, top: Infinity, right: -Infinity, bottom: -Infinity, width: 0, height: 0 })
        : (targetMark || target).getBoundingClientRect();
      const naturalWidth = wordmark.offsetWidth || 1;
      const naturalHeight = wordmark.offsetHeight || 1;
      const styles = getComputedStyle(home);
      const dockWidth = parseFloat(styles.getPropertyValue('--co-wordmark-dock-width')) || 158;
      const dockScale = Math.min(1, dockWidth / naturalWidth, Math.max(0.01, (targetBox.height - 8) / naturalHeight));
      const endX = targetBox.left;
      const endY = targetBox.top;
      wordmark.style.setProperty('--co-wordmark-start-x', `${(originBox.left - naturalWidth / 2).toFixed(2)}px`);
      wordmark.style.setProperty('--co-wordmark-start-y', `${(originBox.top + window.scrollY).toFixed(2)}px`);
      wordmark.style.setProperty('--co-wordmark-end-x', `${endX.toFixed(2)}px`);
      wordmark.style.setProperty('--co-wordmark-end-y', `${endY.toFixed(2)}px`);
      wordmark.style.setProperty('--co-wordmark-dock-scale', dockScale.toFixed(4));
      wordmark.style.setProperty('--co-wordmark-travel', `${Math.min(430, hero.offsetHeight * 0.55).toFixed(0)}px`);
      wordmark.classList.toggle('is-reduced', reducedMotion.matches);
      home.classList.toggle('is-wordmark-docked', reducedMotion.matches || window.scrollY > 90);
    }

    if (scrollLinked) {
      // The hero wordmark is positioned with CSS; JS owns the dock state so
    // browsers cannot produce a second, offset scroll-timeline copy.
    } else {
      // The scroll listener below owns the same handoff in browsers without
      // scroll-timeline support, keeping the timing identical everywhere.
    }
    // Keep the header/hero handoff deterministic even when scroll-timeline is
    // unavailable or delayed by the browser. This also prevents two logos
    // being visible together on compact screens.
    let scrollTick = false;
    let dockTimer;
    let dockIntent = false;
    const syncDockState = () => {
      scrollTick = false;
      const docked = window.scrollY > 90;
      if (docked === dockIntent) return;
      dockIntent = docked;
      window.clearTimeout(dockTimer);
      if (docked) {
        wordmark.classList.add('is-docking');
        wordmark.classList.remove('is-docked');
        home.classList.remove('is-wordmark-docked');
        dockTimer = window.setTimeout(() => {
          if (!dockIntent) return;
          wordmark.classList.remove('is-docking');
          wordmark.classList.add('is-docked');
          home.classList.add('is-wordmark-docked');
        }, 680);
      } else {
        wordmark.classList.remove('is-docking', 'is-docked');
        home.classList.remove('is-wordmark-docked');
      }
    };
    window.addEventListener('scroll', () => {
      if (!scrollTick) {
        scrollTick = true;
        window.requestAnimationFrame(syncDockState);
      }
    }, { passive: true });
    const resizeObserver = new ResizeObserver(measure);
    resizeObserver.observe(home);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
    reducedMotion.addEventListener && reducedMotion.addEventListener('change', measure);
    measure();
    syncDockState();
  }

  function init(root) { root.querySelectorAll('[data-co-wordmark]').forEach(setupWordmark); }

  function setupCapabilityExperience() {
    const panels = document.querySelectorAll('[data-co-capability-panel]');
    if (!panels.length) return;
    const targetId = decodeURIComponent(window.location.hash.slice(1));
    panels.forEach((panel) => {
      if (targetId && panel.id === targetId) panel.classList.add('is-visible');
    });
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      panels.forEach((panel) => panel.classList.add('is-visible'));
      return;
    }
    const observer = new IntersectionObserver((entries, instance) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        instance.unobserve(entry.target);
      });
    }, { threshold: 0.18, rootMargin: '0px 0px -8% 0px' });
    panels.forEach((panel) => observer.observe(panel));
  }

  function setupDepartmentFilters() {
    const grid = document.querySelector('#product-grid[data-id]');
    const links = document.querySelectorAll('[data-department-filter]');
    if (!grid || !links.length) return;
    const department = new URLSearchParams(window.location.search).get('department') || 'all';
    const requestedPage = Math.max(1, Number(new URLSearchParams(window.location.search).get('page')) || 1);
    const pageSize = 16;
    const items = [...grid.querySelectorAll(':scope > li[data-departments]')];
    const matchingItems = items.filter((item) => {
      const departments = item.dataset.departments.split(/\s+/);
      return department === 'all' || departments.includes(department);
    });
    const totalPages = Math.max(1, Math.ceil(matchingItems.length / pageSize));
    const currentPage = Math.min(requestedPage, totalPages);
    if (requestedPage !== currentPage) {
      const canonicalUrl = new URL(window.location.href);
      if (currentPage === 1) canonicalUrl.searchParams.delete('page');
      else canonicalUrl.searchParams.set('page', currentPage);
      window.history.replaceState({}, '', `${canonicalUrl.pathname}${canonicalUrl.search}${canonicalUrl.hash}`);
    }
    const pageStart = (currentPage - 1) * pageSize;
    const pageItems = new Set(matchingItems.slice(pageStart, pageStart + pageSize));
    items.forEach((item) => { item.hidden = !pageItems.has(item); });
    links.forEach((link) => {
      const active = link.dataset.departmentFilter === department;
      link.classList.toggle('is-active', active);
      if (active) link.setAttribute('aria-current', 'page');
      else link.removeAttribute('aria-current');
    });
    const pagination = document.querySelector('[data-department-pagination]');
    if (pagination) {
      pagination.replaceChildren();
      pagination.hidden = totalPages <= 1;
      if (totalPages > 1) {
        const makeLink = (label, page, current) => {
          const link = document.createElement('a');
          const target = new URL(window.location.href);
          if (page <= 1) target.searchParams.delete('page');
          else target.searchParams.set('page', page);
          if (department === 'all') target.searchParams.delete('department');
          else target.searchParams.set('department', department);
          link.href = `${target.pathname}${target.search}${target.hash}`;
          link.textContent = label;
          link.className = 'co-department-pagination__link';
          if (current) link.setAttribute('aria-current', 'page');
          return link;
        };
        if (currentPage > 1) pagination.append(makeLink('Previous', currentPage - 1, false));
        for (let page = 1; page <= totalPages; page += 1) {
          pagination.append(makeLink(String(page), page, page === currentPage));
        }
        if (currentPage < totalPages) pagination.append(makeLink('Next', currentPage + 1, false));
      }
    }
    const empty = document.querySelector('[data-department-empty]');
    if (empty) empty.hidden = matchingItems.length > 0;
  }

  function setupCommerceOverlays() {
    const search = document.querySelector('[data-co-search-overlay]');
    const searchInput = search && search.querySelector('input[type="search"]');
    const openSearch = () => {
      if (!search) return;
      search.hidden = false;
      search.setAttribute('aria-hidden', 'false');
      document.body.classList.add('co-search-open');
      window.requestAnimationFrame(() => searchInput && searchInput.focus());
    };
    const closeSearch = () => {
      if (!search) return;
      search.hidden = true;
      search.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('co-search-open');
    };
    document.querySelectorAll('[data-co-search-trigger]').forEach((trigger) => {
      trigger.addEventListener('click', (event) => { event.preventDefault(); openSearch(); });
    });
    search && search.querySelectorAll('[data-co-search-close]').forEach((button) => button.addEventListener('click', closeSearch));
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && search && !search.hidden) closeSearch(); });

    document.querySelectorAll('[data-co-cart-trigger]').forEach((trigger) => {
      trigger.addEventListener('click', (event) => {
        const drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.open === 'function') { event.preventDefault(); drawer.open(trigger); }
      });
    });
    document.querySelectorAll('[data-co-add-to-cart]').forEach((form) => {
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        const button = form.querySelector('button[type="submit"]');
        if (!button || button.disabled) return;
        const originalLabel = button.textContent;
        button.disabled = true;
        button.textContent = 'Adding';
        try {
          const response = await fetch(`${form.action}.js`, {
            method: 'POST',
            headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: new FormData(form),
          });
          if (!response.ok) throw new Error('Unable to add this item');
          const item = await response.json();
          const drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.renderContents === 'function') {
            const sections = await fetch('/?sections=cart-drawer,cart-icon-bubble', { headers: { Accept: 'application/json' } }).then((result) => result.json());
            drawer.renderContents({ sections, id: item.id });
          } else {
            document.dispatchEvent(new CustomEvent('cart:refresh'));
          }
          button.textContent = 'Added';
          window.setTimeout(() => { button.textContent = originalLabel; button.disabled = false; }, 1200);
        } catch (error) {
          button.textContent = 'Try again';
          window.setTimeout(() => { button.textContent = originalLabel; button.disabled = false; }, 1600);
        }
      });
    });
    const refreshCartCount = () => fetch('/cart.js').then((response) => response.json()).then((cart) => {
      document.querySelectorAll('[data-co-cart-count]').forEach((count) => { count.textContent = String(cart.item_count).padStart(2, '0'); });
    }).catch(() => {});
    refreshCartCount();
    ['cart:refresh', 'cart:updated', 'product-form:added'].forEach((eventName) => document.addEventListener(eventName, refreshCartCount));
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setupCommerceOverlays);
  else setupCommerceOverlays();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setupDepartmentFilters);
  else setupDepartmentFilters();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setupCapabilityExperience);
  else setupCapabilityExperience();
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
